import { render } from "./ChannelCheer.vue?vue&type=template&id=7c98b483"
import script from "./ChannelCheer.vue?vue&type=script&lang=ts"
export * from "./ChannelCheer.vue?vue&type=script&lang=ts"
script.render = render

export default script